/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import { createJpdExperience } from './createJpdExperience.tsx';
import type { JPDExperience } from './ExperienceMetadataExtra.types.tsx';

export const pageSegmentLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.idea-view-bento-sidebar', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);
